// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EcSZim48KRlba8oVFbuh {
  text-decoration: underline;
  display: inline-block;
  max-width: 100%;
}

._rOmM_3rRSWWYchz3_jL {
  display: flex;
  column-gap: 0.1rem;
  align-items: center;
  max-width: 100%;
}

.GzLmBJeo_5fCykNNQm7A {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}
.GzLmBJeo_5fCykNNQm7A .cSi7GwAWA_AMkSun7YqT {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 1rem;
}
.GzLmBJeo_5fCykNNQm7A .cSi7GwAWA_AMkSun7YqT .zytzeEtPD6Wws3Q2_aLe {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.GzLmBJeo_5fCykNNQm7A .cSi7GwAWA_AMkSun7YqT .zytzeEtPD6Wws3Q2_aLe:not(:last-child) {
  margin-bottom: 0.5rem;
}
.GzLmBJeo_5fCykNNQm7A .iG6r3ZabMTdtKiBOV1ZR {
  text-align: center;
  padding-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/report_summary/cards/static_analysis_insights/static-analysis-insights.module.scss"],"names":[],"mappings":"AACA;EACE,0BAAA;EACA,qBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;AAAF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;AAAN;AAEM;EACE,qBAAA;AAAR;AAKE;EACE,kBAAA;EACA,iBAAA;AAHJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.item_link {\n  text-decoration: underline;\n  display: inline-block;\n  max-width: 100%;\n}\n\n.grid_element_with_classification {\n  display: flex;\n  column-gap: 0.1rem;\n  align-items: center;\n  max-width: 100%;\n}\n\n.indicators_grid {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: space-between;\n\n  .file_indicators {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    column-gap: 1rem;\n\n    .indicator {\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: 2;\n\n      &:not(:last-child) {\n        margin-bottom: 0.5rem;\n      }\n    }\n  }\n\n  .more_files {\n    text-align: center;\n    padding-top: 1rem;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item_link": `EcSZim48KRlba8oVFbuh`,
	"grid_element_with_classification": `_rOmM_3rRSWWYchz3_jL`,
	"indicators_grid": `GzLmBJeo_5fCykNNQm7A`,
	"file_indicators": `cSi7GwAWA_AMkSun7YqT`,
	"indicator": `zytzeEtPD6Wws3Q2_aLe`,
	"more_files": `iG6r3ZabMTdtKiBOV1ZR`
};
export default ___CSS_LOADER_EXPORT___;
